// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1zALQ","left":"StickyBox_left__1W3CG","right":"StickyBox_right__1eXw1"};